import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import KeycloakService from '../services/KeycloakService';

const ProtectedRoute = ({ roles, children }) => {
  const location = useLocation();
  const isLoggedIn = KeycloakService.isLoggedIn();
  const path = location.pathname;

  switch (true) {
    case path.startsWith('/user-manage'):
      if (
        !KeycloakService.hasRole(['manager']) &&
        !KeycloakService.hasRole(['senior-manager'])
      )
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      break;

    case path.startsWith('/admin-'):
      if (!KeycloakService.hasRole(['admin']))
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      break;

    case path.startsWith('/hr-'):
      if (!KeycloakService.hasRole(['hr']))
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      break;

    case path.startsWith('/user-'):
      if (
        !(
          KeycloakService.hasRole(['employee']) ||
          KeycloakService.hasRole(['manager'])
        )
      )
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      break;

    case path.startsWith('/tech-council'):
      if (!KeycloakService.hasRole(['tech-council']))
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      break;

    case path.startsWith('/finance-'):
      if (!KeycloakService.hasRole(['finance']))
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      break;
    case path.startsWith('/senior-manager'):
      if (!KeycloakService.hasRole(['senior-manager']))
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      break;
    case path.startsWith('/project-admin'):
      if (!KeycloakService.hasRole(['project-admin'])) {
        return (
          <Navigate to={roles[0].url} state={{ from: location }} replace />
        );
      }
      break;
    default:
      break;
  }
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  } else {
    return children;
  }
};

export default ProtectedRoute;
